module.exports = __webpack_public_path__ + "img/verified.a5d1ec60.svg";